import { gql } from "@apollo/client";

// Ignore weirdly named query, it gets all teachers.
// Only id/firstname/lastname/email are consumed (teacher-picker on add/edit class;
// email is shown to disambiguate same-named teachers). We deliberately request nothing
// else — pulling colleagues' phone, webhooks, 2FA/sync state etc. into a teacher's
// browser would needlessly widen the exposure of the underlying school-scoped user list.
export const GET_TEACHERS_QUERY = gql`
  query currentSchoolUsers($q: String) {
    currentSchoolUsers(q: $q) {
      ... on UserConnection {
        edges {
          node {
            id
            firstname
            lastname
            email
          }
        }
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;
